module.exports = __webpack_public_path__ + "static/media/gym_fulltime.67d559cd.png";